import { Route, Routes as ModuleRoutes } from '@direct-frontend/modules-router';
import { RumWrapper } from '@adv-frontend/yastore-modules/lib';
import { ClientsListAsync } from '#pages/clients';
import { ImportUsersFromExcelAsync } from '#pages/importUsersFromExcel';
import { NotFound } from '#pages/notFound';
import { OrdersListAsync } from '#pages/orders';
import { ProductsDashboardAsync } from '#pages/products';
import { SettingsAboutAsync } from '#pages/settings-about';
import { SettingsBuyButtonAsync } from '#pages/settings-buy-button';
import { SettingsEmailNotificationsAsync } from '#pages/settings-email-notifications';
import { SettingsFeedAsync } from '#pages/settings-feed';
import { SettingsYaMetrikaAsync } from '#pages/settings-integrations';
import { SettingsLogisticsAsync } from '#pages/settings-logistics';
import { SettingsLogisticsWarehouseAsync } from '#pages/settings-logisticsWarehouse';
import { SettingsManagersAsync } from '#pages/settings-managers';
import { SettingsOtherAsync } from '#pages/settings-other';
import { SettingsPaymentAsync } from '#pages/settings-payment';
import { SettingsTestOrder } from '#pages/settings-testOrder';
import { SettingsYcpAsync } from '#pages/settings-ycp';
import { ErrorBoundaryRouterWrapper } from '#shared/components/ErrorBoundary';
import { RedirectWithSearchParams } from '#shared/components/RedirectWithSearchParams';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { pathToPageName } from '#shared/lib/dom';
import {
    clientsImportExcelRoute,
    clientsRoute,
    ordersRoute,
    productsRoute,
    settingsAboutRoute,
    settingsBuyButtonRoute,
    settingsEmailNotificationsRoute,
    settingsLogisticsRoute,
    settingsLogisticsWarehouseEditRoute,
    settingsManagersRoute,
    settingsOtherRoute,
    settingsPaymentRoute,
    settingsProductFeedRoute,
    settingsRoute,
    settingsTestOrderRoute,
    settingsYaMetrikaRoute,
    settingsYcpRoute,
} from '#shared/lib/routes';
import { checkIsBitrixStore } from '#shared/lib/storeInfo';
import { ApplicationLayoutRoute } from '../ApplicationLayout';
import { DashboardLayout, SettingsLayout } from '../DashboardLayout';

export const ExternalRoutes = () => {
    const { isInternalYandexUser } = getSafeUserRequestContext();

    return (
        <ModuleRoutes>
            <Route element={<RumWrapper pathToPageName={pathToPageName} />}>
                <Route element={<ErrorBoundaryRouterWrapper />}>
                    <Route element={<ApplicationLayoutRoute />}>
                        <Route element={<DashboardLayout />}>
                            <Route
                                path="/"
                                element={<RedirectWithSearchParams to={settingsAboutRoute.route} replace />}
                            />
                            <Route path={productsRoute.route} element={<ProductsDashboardAsync />} />
                            <Route path={ordersRoute.route} element={<OrdersListAsync />} />
                            <Route path={clientsRoute.route} element={<ClientsListAsync />} />
                            <Route path={clientsImportExcelRoute.route} element={<ImportUsersFromExcelAsync />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                        <Route path={settingsRoute.route} element={<SettingsLayout />}>
                            <Route path={settingsAboutRoute.route} element={<SettingsAboutAsync />} />
                            <Route path={settingsManagersRoute.route} element={<SettingsManagersAsync />} />
                            <Route path={settingsLogisticsRoute.route} element={<SettingsLogisticsAsync />} />
                            <Route
                                path={settingsLogisticsWarehouseEditRoute.route}
                                element={<SettingsLogisticsWarehouseAsync />}
                            />
                            <Route path={settingsPaymentRoute.route} element={<SettingsPaymentAsync />} />
                            <Route
                                path={settingsEmailNotificationsRoute.route}
                                element={<SettingsEmailNotificationsAsync />}
                            />
                            <Route path={settingsTestOrderRoute.route} element={<SettingsTestOrder />} />
                            <Route path={settingsYaMetrikaRoute.route} element={<SettingsYaMetrikaAsync />} />
                            {checkIsBitrixStore() && (
                                <Route path={settingsBuyButtonRoute.route} element={<SettingsBuyButtonAsync />} />
                            )}
                            <Route path={settingsProductFeedRoute.route} element={<SettingsFeedAsync />} />
                            <Route path={settingsYcpRoute.route} element={<SettingsYcpAsync />} />
                            {isInternalYandexUser && (
                                <Route path={settingsOtherRoute.route} element={<SettingsOtherAsync />} />
                            )}
                            <Route
                                path={settingsRoute.route}
                                element={<RedirectWithSearchParams to={settingsAboutRoute.route} replace />}
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>
        </ModuleRoutes>
    );
};
